<template>
  <b-container fluid class="div-background">
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
        :show="messageObject.success.count"
        dismissible
        @dismissed="messageObject.success.count = 0"
        @dismiss-count-down="successCountChanged"
        >{{ messageObject.success.content }}
      </b-alert>
    <b-alert
      :show="messageObject.warning.count"
      variant="danger"
      dismissible
      @dismissed="messageObject.warning.count = 0"
      @dismiss-count-down="warningCountChanged"
      >{{ messageObject.warning.content }}
    </b-alert>
    <b-row align-h="center">
      <b-col md="5" class="setdivheight">
        <h2>帳號綁定</h2>
        <b-form-group
          label="請輸入原帳號："
        >
          <b-form-input
            v-model="Accountobject.userid.value"
            aria-describedby="userid-feedback"
            :state="Accountobject.userid.state"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback id="userid-feedback">
            {{ Accountobject.userid.message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="請輸入原帳號密碼："
        >
          <b-form-input
            v-model="Accountobject.pwd.value"
            aria-describedby="pwd-feedback"
            :state="Accountobject.pwd.state"
            type="password"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback id="pwd-feedback">
            {{ Accountobject.pwd.message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button @click="callModal" block size="lg" variant="primary"
          >綁定帳號</b-button
        >
      </b-col>
    </b-row>
    <b-modal
      id="modal-changepassword"
      ref="binding"
      title="綁定帳號"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      確定要綁定帳號?
    </b-modal>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      PassToken: this.$route.query.Token,
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#",
        },
        {
          text: "綁定帳號",
          active: true,
        },
      ],
      Accountobject: {
        userid: {
          value: null,
          state: null,
          message: "欄位不能為空值",
        },
        pwd: {
          value: null,
          state: null,
          message: "密碼不能為空值",
        },
      },
      messageObject: {
        warning: {
          show: false,
          content: null,
          count: 0,
        },
        success: {
          //show: false,
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      apiBindingAccount: (data) =>
        this.userRequest.post("API/Default/BindingAccount", data),
    };
  },
  methods: {
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    bindingAccount(data) {
      this.apiBindingAccount(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          //console.log(json);
          if (json.Status) {
            //alert("綁定成功，請重新登入")
            sessionStorage.removeItem("TokenID");
            sessionStorage.removeItem("username");
            sessionStorage.removeItem("isLine");
            sessionStorage.removeItem("lineUserid");
            this.suceessPopUp("綁定成功，請重新登入，將自動轉跳登入畫面");

            setTimeout(function () {
              window.location.assign("https://agri-data.cyhg.gov.tw/#/login");
              window.location.reload();
            }, 3000) // 1000毫秒 = 1秒
            
          }
          else{
            this.warningPopUp(json.Message);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    callModal() {
      if (
        this.Accountobject.userid.value == "" ||
        this.Accountobject.userid.value == null ||
        this.Accountobject.pwd.value == "" ||
        this.Accountobject.pwd.value == null
      ) {
        this.warningPopUp("欄位不能為空值");
      }else if (
        this.Accountobject.userid.state == false
      ) {
        this.warningPopUp("信箱格式有誤");
      } else {
        this.$refs["binding"].show();
      }
    },
    resetModal() {
      this.$refs["binding"].hide();
    },
    handleOk() {
      let data ={
        AC_USERID : this.Accountobject.userid.value,
        AC_pwd: this.Accountobject.pwd.value,
        lineuserid : this.lineuserid
      }
      this.FunctionToken(this.bindingAccount, data);
    },
    warningPopUp(msg) {
      this.messageObject.warning.count = this.messageObject.dismissSecs;
      this.messageObject.warning.content = msg;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
    warningCountChanged(count) {
      this.messageObject.warning.count = count;
    },
  },
  watch: {
    "Accountobject.userid.value"(val){
      if (this.IsNull(val) == "") {
        this.Accountobject.userid.state = false;
        this.Accountobject.userid.message = "必填欄位";
      } else if (!this.validEmail(val)) {
        this.Accountobject.userid.state = false;
        this.Accountobject.userid.message = "Email格式錯誤";
      } else {
        this.Accountobject.userid.state = true;
      }
    }
  },
};
</script>
